import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Slick from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/style.css";

// const products = {
//     outdoor: [
//         {
//             id: 1,
//             image: "/img/catalog/1.jpg",
//             name: "Видеоэкран Р10",
//             price: "от 38000 ₽",
//             category: "Уличные экраны",
//             description: "Светодиодный полноцветный видеоэкран для улицы P10",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10%, 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Алюминий" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/2" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H160° V160°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//             ],
//         },
//         {
//             id: 2,
//             image: "/img/catalog/2.jpg",
//             name: "Видеоэкран Р8",
//             price: "от 46000 ₽",
//             category: "Уличные экраны",
//             description: "Светодиодный полноцветный видеоэкран для улицы P8",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10%, 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Алюминий" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/4S" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H170° V120°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//             ],
//         },
//     ],
//     indoor: [
//         {
//             id: 3,
//             image: "/img/catalog/1.jpg",
//             name: "Видеоэкран Р5",
//             price: "от 46000 ₽",
//             category: "Экран для помещения",
//             description: "Светодиодный полноцветный видеоэкран для помещения P5",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10%, 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Скан модуля", value: "1/16S" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H160° V160°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//                 { name: "Цветность", value: "16 Бит" },
//                 { name: "Частота обновления", value: "960 Гц" },
//             ],
//         },
//         {
//             id: 4,
//             image: "/img/catalog/2.jpg",
//             name: "Видеоэкран Р4",
//             price: "от 47000 ₽",
//             category: "Экран для помещения",
//             description: "Светодиодный полноцветный видеоэкран для улицы P4",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10%, 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Скан модуля", value: "1/16S" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H160° V160°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//                 { name: "Цветность", value: "16 Бит" },
//                 { name: "Частота обновления", value: "960 Гц" },
//             ],
//         },
//     ],
//     videopylon: [
//         {
//             id: 5,
//             image: "/img/catalog/1.jpg",
//             name: "LEDOKS LP-S",
//             price: "от 135000 ₽",
//             category: "Видеопилон",
//             description: "Светодиодный видеопилон LEDOKS LP-S",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10% , 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Сталь, п/э" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/2" },
//                 { name: "Срок изготовления", value: "7 дней" },
//                 { name: "Срок поставки", value: "2-3 дня" },
//                 { name: "Срок службы", value: "100 000 ч" },
//             ],
//         },
//         {
//             id: 6,
//             image: "/img/catalog/2.jpg",
//             name: "LEDOKS LP-L",
//             price: "от 150000 ₽",
//             category: "Видеопилон",
//             description: "Светодиодный видеопилон LEDOKS LP-L",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10% , 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Сталь, п/э" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/2" },
//                 { name: "Срок изготовления", value: "7 дней" },
//                 { name: "Срок поставки", value: "2-3 дня" },
//                 { name: "Срок службы", value: "100 000 ч" },
//             ],
//         },
//     ],
//     forstage: [
//         {
//             id: 7,
//             image: "/img/catalog/1.jpg",
//             name: "Экран 6х3",
//             price: "от 810000 ₽",
//             category: "Экран для сцены",
//             description: "Светодиодный экран 6х3",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10%, 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Алюминий" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/2" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H160° V160°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//             ],
//         },
//         {
//             id: 8,
//             image: "/img/catalog/2.jpg",
//             name: "Экран 12х5",
//             price: "от 1000000 ₽",
//             category: "Экран для сцены",
//             description: "Светодиодный экран 12х5",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10% 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Алюминий" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/2" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H160° V160°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//             ],
//         },
//     ],
//     onfacade: [
//         {
//             id: 9,
//             image: "/img/catalog/1.jpg",
//             name: "Медиафасад P16",
//             price: "от 82000 ₽",
//             category: "Экран на фасаде",
//             description: "Медиафасад P16 светодиодный полноцветный",
//             characteristics: [
//                 { name: "Размер рейки", value: "1500х250х68 мм" },
//                 { name: "Разрешение", value: "90x15" },
//                 { name: "Светопропускаемость", value: "16%" },
//                 { name: "Угол обзора", value: "H100° V100°" },
//                 { name: "Шаг пикселя", value: "16 мм" },
//                 { name: "Гарантия", value: "от 1 до 3 лет" },
//                 { name: "Яркость", value: "7000 cd" },
//                 { name: "Вес", value: "7,8 кг/шт" },
//             ],
//         },
//         {
//             id: 10,
//             image: "/img/catalog/2.jpg",
//             name: "Пилон 3x7",
//             price: "от 950000 ₽",
//             category: "Экран на фасаде",
//             description: "Светодиодный пилон 3x7",
//             characteristics: [
//                 { name: "Входное напряжение", value: "AC220/110±10% , 50/60Гц" },
//                 { name: "Контрастность", value: "3000:01:00" },
//                 { name: "Материал корпуса", value: "Алюминий" },
//                 { name: "Режим обслуживания", value: "Задняя часть" },
//                 { name: "Скан модуля", value: "1/2" },
//                 { name: "Срок службы", value: "100 000 ч (~8 лет непрерывной эксплуатации)" },
//                 { name: "Угол обзора", value: "H160° V160°" },
//                 { name: "Уровень серого", value: "14 Бит" },
//             ],
//         },
//     ],
// };

const products = {
    outdoor: [
        {
            id: 1,
            image: "/img/catalog/outdoor_1.jpg",
            name: "Видеоэкран Р6",
            price: "от 56 000 ₽",
            category: "Уличные экраны",
            description: "Уличный светодиодный экран P6",
            characteristics: [
                { name: "Шаг пикселя", value: "P6" },
                { name: "Яркость", value: "5500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Алюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
        {
            id: 2,
            image: "/img/catalog/outdoor_2.jpg",
            name: "Видеоэкран Р4",
            price: "от 68 000 ₽",
            category: "Уличные экраны",
            description: "Уличный светодиодный экран P4",
            characteristics: [
                { name: "Шаг пикселя", value: "P4" },
                { name: "Яркость", value: "5500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Алюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
    ],
    indoor: [
        {
            id: 3,
            image: "/img/catalog/indoor_1.jpg",
            name: "Видеоэкран Р4",
            price: "от 59 000 ₽",
            category: "Экран для помещения",
            description: "Светодиодный экран для помещения P4",
            characteristics: [
                { name: "Шаг пикселя", value: "P4" },
                { name: "Яркость", value: "От 500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Алюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
        {
            id: 4,
            image: "/img/catalog/indoor_2.jpg",
            name: "Видеоэкран P3,07",
            price: "от 67 000 ₽",
            category: "Экран для помещения",
            description: "Светодиодный экран для помещения P3,07",
            characteristics: [
                { name: "Шаг пикселя", value: "P3,07" },
                { name: "Яркость", value: "От 500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Алюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
    ],
    videopylon: [
        {
            id: 5,
            image: "/img/catalog/videopylon_1.jpg",
            name: "Видеопилон P4",
            price: "от 250 000 ₽",
            category: "Видеопилон",
            description: "Светодиодный видеопилон P4",
            characteristics: [
                { name: "Шаг пикселя", value: "P4" },
                { name: "Яркость", value: "От 5500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Сталь" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
        {
            id: 6,
            image: "/img/catalog/videopylon_2.jpg",
            name: "Видеопилон P3",
            price: "от 310 000 ₽",
            category: "Видеопилон",
            description: "Светодиодный видеопилон P3",
            characteristics: [
                { name: "Шаг пикселя", value: "P3" },
                { name: "Яркость", value: "От 5500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Сталь" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
    ],
    forstage: [
        {
            id: 7,
            image: "/img/catalog/forstage_1.jpg",
            name: "Экран 6х3",
            price: "от 1 310 000 ₽",
            category: "Экран для сцены",
            description: "Светодиодный экран 6х3",
            characteristics: [
                { name: "Шаг пикселя", value: "P4" },
                { name: "Яркость", value: "От 500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Алюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
        {
            id: 8,
            image: "/img/catalog/forstage_2.jpg",
            name: "Экран 12х5",
            price: "от 4 200 000 ₽",
            category: "Экран для сцены",
            description: "Светодиодный экран 12х5",
            characteristics: [
                { name: "Шаг пикселя", value: "P3,07" },
                { name: "Яркость", value: "От 500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Алюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
    ],
    onfacade: [
        {
            id: 9,
            image: "/img/catalog/onfacade_1.jpg",
            name: "P1531 Pro",
            price: "от 120 000 ₽",
            category: "Экран на фасаде",
            description: "Медиафасад P1531 Pro",
            characteristics: [
                { name: "Шаг пикселя", value: "P1531 Pro" },
                { name: "Яркость", value: "От 800" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Металл" },
                { name: "Вес", value: "20кг/кв.м" },
                { name: "Прозрачность", value: "68%" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
        {
            id: 10,
            image: "/img/catalog/onfacade_2.jpg",
            name: "Пилон 3x6",
            price: "от 950 000 ₽",
            category: "Экран на фасаде",
            description: "Светодиодный пилон 3x6",
            characteristics: [
                { name: "Шаг пикселя", value: "P4" },
                { name: "Яркость", value: "От 5500" },
                { name: "Частота обновления", value: "От 1920 Гц" },
                { name: "Материал корпуса", value: "Аллюминий" },
                { name: "Режим обслуживания", value: "Тыловое/Фронтальное" },
                { name: "Срок службы", value: "100 000 ч (более 10 лет непрерывной эксплуатации)" },
            ],
        },
    ],
};

export default function Catalog() {
    const [selectedFilter, setSelectedFilter] = useState("outdoor");
    const [isMobile, setIsMobile] = useState(false);
    const [hoveredProduct, setHoveredProduct] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize(); // Проверка при монтировании
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleFilterClick = (filter) => {
        setSelectedFilter(filter);
    };

    const currentProducts = products[selectedFilter];
    const announcementText = selectedFilter === "outdoor" ? "Индивидуальный Led экран под ваш запрос" : "Индивидуальный Led экран под ваш запрос";

    const settings = {
        dots: false, // Отключаем точки
        arrows: false, // Отключаем стрелки
        infinite: false, // Отключаем бесконечное пролистывание
        speed: 500,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        centerMode: false, // Включаем центрирование
    };

    return (
        <section id="catalog" className="catalog">
            <Container className="sect">
                <h2 className="title">Каталог</h2>
                <p className="t28 inscription">Подберем led экран под любое мероприятие</p>
                <div className="all_block">
                    <div className="filters n_one">
                        <div className={`item ${selectedFilter === "outdoor" ? "active" : ""}`} onClick={() => handleFilterClick("outdoor")}>
                            <div className="text">Уличные экраны</div>
                            <img className="picture" src="/img/1.png" alt="Уличные экраны" />
                        </div>
                        <div className={`item ${selectedFilter === "indoor" ? "active" : ""}`} onClick={() => handleFilterClick("indoor")}>
                            <div className="text">Экран для помещения</div>
                            <img className="picture" src="/img/2.png" alt="Экран для помещения" />
                        </div>
                        <div className={`item ${selectedFilter === "videopylon" ? "active" : ""}`} onClick={() => handleFilterClick("videopylon")}>
                            <div className="text">Видеопилон</div>
                            <img className="picture" src="/img/3.png" alt="Видеопилон" />
                        </div>
                        <div className={`item ${selectedFilter === "forstage" ? "active" : ""}`} onClick={() => handleFilterClick("forstage")}>
                            <div className="text">Экран для сцены</div>
                            <img className="picture" src="/img/4.png" alt="Экран для сцены" />
                        </div>
                        <div className={`item ${selectedFilter === "onfacade" ? "active" : ""}`} onClick={() => handleFilterClick("onfacade")}>
                            <div className="text">Экран на фасаде</div>
                            <img className="picture" src="/img/5.png" alt="Экран на фасаде" />
                        </div>
                    </div>
                    <div className={`slider-container n_two ${isMobile ? "slick-slider-container" : ""}`}>
                        {isMobile ? (
                            <Slick {...settings} className="slider">
                                {currentProducts.map((product) => (
                                    <div key={product.id} className="slider-item">
                                        <div
                                            className="product"
                                            onMouseEnter={() => setHoveredProduct(product.id)}
                                            onMouseLeave={() => setHoveredProduct(null)}>
                                            <div className="product_picture">
                                                <img src={product.image} alt={product.name} />
                                                <p className="name">{product.name}</p>
                                            </div>
                                            <div className="text_block">
                                                <p className="price">{product.price}</p>
                                                <p className="category">{product.category}</p>
                                                <p className="description">{product.description}</p>
                                            </div>
                                            {hoveredProduct === product.id && (
                                                <div className="characteristics-overlay">
                                                    <div className="characteristics">
                                                        <div className="elem_price">
                                                            <p>{product.price}</p>
                                                        </div>
                                                        <div className="elem_category">
                                                            <p>{product.category}</p>
                                                        </div>
                                                        <div className="elem_description">
                                                            <p>{product.description}</p>
                                                        </div>
                                                        {product.characteristics.map((char, index) => (
                                                            <div key={index} className="elem">
                                                                <p className="elem_name">{char.name}</p>
                                                                <p>{char.value}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {isMobile && (
                                                        <button className="close-button" onClick={() => setHoveredProduct(null)}>
                                                            &times;
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </Slick>
                        ) : (
                            <div className="slider">
                                {currentProducts.map((product) => (
                                    <div
                                        className="product"
                                        key={product.id}
                                        onMouseEnter={() => setHoveredProduct(product.id)}
                                        onMouseLeave={() => setHoveredProduct(null)}>
                                        <div className="product_picture">
                                            <img src={product.image} alt={product.name} />
                                            <p className="name">{product.name}</p>
                                        </div>
                                        <div className="text_block">
                                            <p className="price">{product.price}</p>
                                            <p className="category">{product.category}</p>
                                            <p className="description">{product.description}</p>
                                        </div>
                                        {hoveredProduct === product.id && (
                                            <div className="characteristics-overlay">
                                                <div className="characteristics">
                                                    <div className="elem_price">
                                                        <p>{product.price}</p>
                                                    </div>
                                                    <div className="elem_category">
                                                        <p>{product.category}</p>
                                                    </div>
                                                    <div className="elem_description">
                                                        <p>{product.description}</p>
                                                    </div>
                                                    {product.characteristics.map((char, index) => (
                                                        <div key={index} className="elem">
                                                            <p>{char.name}</p>
                                                            <p>{char.value}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                                {isMobile && (
                                                    <button className="close-button" onClick={() => setHoveredProduct(null)}>
                                                        &times;
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="announcement n_three">
                        <div className="picture">
                            <img src="/img/catalog/announcement.png" alt="предложение" />
                        </div>
                        <div className="content">
                            <p className="title">{announcementText}</p>
                            <p className="text">Просто оставьте заявку<br/>на сайте / в WhatsApp или позвоните по телефону</p>
                            <a className="number" href="tel:+79278223311">
                                +7-927-822-33-11
                            </a>
                            <p className="text">
                                проконсультируем Вас, предоставим КП и сопутствующие материалы <b>бесплатно</b> в течение 24 часов
                            </p>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}
